import { render, staticRenderFns } from "./BusinessRuleExplanation.vue?vue&type=template&id=54d0bd62&"
import script from "./BusinessRuleExplanation.vue?vue&type=script&lang=js&"
export * from "./BusinessRuleExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports